//追缴规则
const RuleConfiguration = () => import(/*webpackChunkName:'sale'*/"@/page/sale/arrearsRecovery/ruleConfiguration.vue")
const ArrearsList =()=>import(/*webpackChunkName:'sale'*/"@/page/sale/arrearsRecovery/arrearsList.vue")
const RouteTemp = () => import(/*webpackChunkName:'sale'*/'@/page/commons/routeTemp.vue')

export  const recoveryRules=
    {
        path: '/main/arrears-recovery',
        name: '欠费追缴',
        meta: {
            requireAuth: true,
        },
        component: RouteTemp,
        children: [{
            path: '/main/recovery-rules/rule-configuration',
            name: '规则设置',
            meta: {
                requireAuth: true,
            },
            component: RuleConfiguration
        },
        {
            path: '/main/recovery-rules/arrears-list',
            name: '欠费列表',
            meta: {
                requireAuth: true,
            },
            component: ArrearsList
        },
       ]
    }